<div class="main-content" style="margin-top: 50px;">
    <div class="container-fluid">
        <div class="col">
            <div class="card ">
                <div class="card-header card-header-primary p-1">
                    <div class="row">
                        <div class="col-sm-10 col-md-10">
                            <h4 class="card-title mt-2 ml-2 font-weight-bold">Procesar ticket</h4>
                        </div>
                        <div class="col-sm-2 col-md-2">
                            <button mat-icon-button (click)="onCloseClick()" tabindex="0">
                                <mat-icon>clear</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <form [formGroup]='comentarioForm'>
                    <div class="card-body text-default">
                        <h4> Para enviar a proceso es necesario
                            indicar si el <span class="font-weight-bold">recurso solicitado</span> se encuentra disponible:</h4>
                        <div>
                            <!-- <mat-radio-group aria-label="Recurso disponible">
                                <mat-radio-button class="radio-recurso" value="1">Sí</mat-radio-button>
                                <mat-radio-button class="radio-recurso" value="2">No, Solicitar a reclutamiento</mat-radio-button>
                              </mat-radio-group> -->
                              <mat-chip-listbox aria-label="Recurso disponible"  formControlName="fooBar" >
                                <mat-chip-option>Sí</mat-chip-option>
                                <mat-chip-option>No, Solicitar reclutamiento</mat-chip-option>
                              </mat-chip-listbox>
                              <mat-form-field class="example-full-width mt-3"  appearance="outline">
                                <mat-label>Comentario:</mat-label>
                                <textarea maxlength="500" matInput aria-label="Comentario:"
                                formControlName='comentarioPerfil'
                                oninput="this.value = this.value.trim().charAt(0).toUpperCase() + this.value.slice(1)"></textarea>
                                <mat-icon matSuffix>spellcheck</mat-icon>
                              </mat-form-field>
                        </div>
                        <div class="text-right">
                                <button mat-raised-button class="btn btn-primary" (click)="limpiar()" ><i class="material-icons">clear</i>Cancelar</button>
                                <button mat-raised-button class="btn btn-warning" (click)="guardar()"  [disabled]="!comentarioForm.valid"><i class="material-icons">settings</i>Proceso</button>
                        </div>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>
